import { __decorate } from "tslib";
import { attr, customElement } from '@microsoft/fast-element';
import { BadgeBase, badgeBaseDefinition } from '../badge.common';
import { ensureDefaultAttribute } from '../../common/utils/Attributes';
export const badgeCounterDefinition = badgeBaseDefinition('chameleon-badge-counter');
let BadgeCounterComponent = class BadgeCounterComponent extends BadgeBase {
    constructor() {
        super(...arguments);
        this.variant = 'danger';
    }
    connectedCallback() {
        super.connectedCallback();
        ensureDefaultAttribute(this, 'variant', 'danger');
        ensureDefaultAttribute(this, 'counter', '');
        this.classList.toggle('dot', !this.textContent);
    }
};
__decorate([
    attr
], BadgeCounterComponent.prototype, "variant", void 0);
BadgeCounterComponent = __decorate([
    customElement(badgeCounterDefinition)
], BadgeCounterComponent);
export { BadgeCounterComponent };
